import * as React from "react";
import * as ReactDOM from "react-dom";
import * as marked from "marked";
import { ICalendar } from "../../models/get";
import { Flyout } from "../flyout";
import { FormGroup } from "../form";
import { ComboBox, ComboBoxType, DROPDOWN_TEXT_ITEM_HEIGHT, DropDownTextItem } from "../comboBox";
import { ScrollViewer, ScrollBarVisibility } from "../scrollViewer";

interface IProperties
{
    /**
     * Ein Wert der angibt ob das Flyout geöffnet ist.
     */
    isOpen: boolean,

    /**
     * Alle eingerichteten Kalender.
     */
    calendars: ICalendar[],

    /**
     * Wird ausgeführt, sobald auf den Close Button oder außerhalb des Flyouts geklickt wird.
     */
    onClose?: () => void
}

interface IState
{
    /**
     * Enthält alle Werte des Forms.
     */
    form?: {
        calendar?: {
            value?: string,
            selectedValue?: number
        }
    },

    /**
     * Enthält die Information die dargestellt werden soll.
     */
    information?: string
}

export class AddressFlyout extends React.Component<IProperties, IState>
{
    /**
     * Erstellt eine neue Instanz der Klasse @see AdressFlyout.
     * @param props Alle gesetzten Eigenschaften.
     */
    constructor(props: IProperties)
    {
        super(props);

        this.state = {
            form: {
                calendar: {}
            }
        }
    }

    private onSelectionChanged = (selectedItem: ICalendar) =>
    {
        this.setState((state: IState) =>
        {
            state.form.calendar = {
                value: selectedItem ? selectedItem.name : null,
                selectedValue: selectedItem ? selectedItem.id : null
            };

            state.information = selectedItem ? selectedItem.information : null;

            return state;
        });
    }

    private renderInformation(): JSX.Element
    {
        const { information } = this.state;
        if (information != null)
        {
            return (
                <div className="fo-address_content markdown">
                    <ScrollViewer
                        style={{
                            top: 25
                        }}
                        HorizontalScrollBarVisibility={ScrollBarVisibility.hidden}
                        VerticalScrollBarVisibility={ScrollBarVisibility.auto}>
                        <div dangerouslySetInnerHTML={{ __html: marked(information) }}></div>
                    </ScrollViewer>
                </div>
            );
        }
        else
        {
            return (
                <div className="fo-address_content fo-address_content--empty">
                    Wählen Sie einen Kalender aus um dessen Adressinformationen anzuzeigen. Kalender bei denen keine Adressinformationen hinterlegt sind, werden nicht in der Auswahl aufgelistet.
                </div>
            );
        }
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { isOpen, calendars, onClose } = this.props;
        const { form } = this.state;

        var filteredCalendars: ICalendar[] = [];
        if (calendars != null)
        {
            filteredCalendars = calendars.where(c => c.information != null)
        }
        
        return (
            <Flyout
                headerText="Adressinformationen"
                width={420}
                alignRight
                isOpen={isOpen}
                onClose={onClose}>
                <div className="fo-address">
                    <div className="fo-address_form">
                        <FormGroup>
                            <ComboBox
                                canRemoveSelection={true}
                                dataSource={filteredCalendars}
                                dropDownMenuItemHeight={DROPDOWN_TEXT_ITEM_HEIGHT}
                                comboBoxType={ComboBoxType.dropDownList}
                                value={form.calendar.value}
                                selectedValue={form.calendar.selectedValue}
                                onSelectionChanged={this.onSelectionChanged}
                                valueMember="id"
                                displayMember="name">
                                {
                                    (item: ICalendar) =>
                                    {
                                        return (
                                            <DropDownTextItem
                                                key={item.id}
                                                value={item.id}
                                                displayValue={item.name} />
                                        );
                                    }
                                }
                            </ComboBox>
                        </FormGroup>
                    </div>
                    {this.renderInformation()}
                </div>
            </Flyout>
        );
    }
}